import { Paragraph } from '@purpur/library';
import { useEffect } from 'react';

type FullPageRedirectProps = {
  to: string;
};

const FullPageRedirect = ({ to }: FullPageRedirectProps) => {
  useEffect(() => {
    // This triggers a full page reload/redirect, not client-side navigation
    window.location.href = to;
  }, [to]);

  return (
    <div>
      <Paragraph>Page not found. Redirecting...</Paragraph>
    </div>
  );
};

export default FullPageRedirect;
